import { Destination2 as Destination } from '~/models/Destination'
import { ApiDestination, ApiDestinationSnippet } from '~/passporter-services/destination/apiTypes'
import { DestinationSnippet } from '~/models/DestinationSnippet'

export class DestinationMapperEntity {
	static toDestination(destination: ApiDestination): Destination {
		return {
			id: destination.id,
			parentId: destination.parent_id,
			name: destination.name,
			address: destination.address,
			location: destination.location,
			cover: destination.cover,
			coverId: destination.cover_id,
			coverProvider: destination.cover_provider,
			type: destination.type,
			travelersCount: destination.num_travelers,
			travelersAvatars: destination.travelers_pictures,
			civitatisTotalActivities: destination.civitatisTotalActivities ?? 0,
			referenceType: 'destination',
			description: destination.description,
			bounds: destination.bounds,
			placeId: destination.place_id,
			standardizedName: destination.standardized_name,
			localizedName: destination.localized_name,
			countryName: destination.country_name,
			countryId: destination.country_id,
			localizedCountryName: destination.localized_country_name,
			standardizedCountryName: destination.standardized_country_name,
			hasCuratedSite: destination.has_curated_site,
			isRecommended: destination.is_recommended ?? false,
			isoCode: destination.iso_code,
			isMonetizable: destination.allow_request_budget ?? false,
		}
	}

	static toDestinations = (destinations: any[]) => {
		return destinations.map((destination) => this.toDestination(destination))
	}

	static toSnippets(snippets: ApiDestinationSnippet[]): DestinationSnippet[] {
		return snippets.map((snippet) => this.toSnippet(snippet))
	}

	static toSnippet(apiSnippet: ApiDestinationSnippet): DestinationSnippet {
		const snippet: DestinationSnippet = {
			title: apiSnippet.title,
			description: apiSnippet.description,
			icon: apiSnippet.icon,
			id: apiSnippet.id,
		}
		return snippet
	}
}
